{
  "title": "Мониторинг критериев",
  "tabs": {
    "label": "Разделы",
    "events": "События",
    "settings": "Настройки звука"
  },
  "levels": {
    "normal": "В норме",
    "m1": "М-1 (Потенциально опасно)",
    "m2": "М-2 (Предаварийное)",
    "m1Full": "Состояние М-1 (Потенциально опасно)",
    "m2Full": "Состояние М-2 (Предаварийное)"
  },
  "kpi": {
    "open": "Активные события",
    "unacknowledged": "Не подтверждены",
    "m1": "События М-1",
    "m2": "События М-2",
    "unit": "{{count}}"
  },
  "filters": {
    "status": "Состояние",
    "level": "Уровень",
    "unack": "Только неподтверждённые",
    "search": "Поиск",
    "total": "Всего: {{count}}",
    "reset": "Сбросить фильтр"
  },
  "status": {
    "open": "Активные",
    "closed": "Закрытые",
    "all": "Все"
  },
  "level": {
    "all": "Все уровни",
    "m1": "М-1",
    "m2": "М-2"
  },
  "columns": {
    "level": "Уровень",
    "indicator": "Показатель",
    "device": "Устройство",
    "startedAt": "Начало",
    "duration": "Длительность",
    "peak": "Пиковое значение",
    "threshold": "Порог",
    "state": "Состояние",
    "ack": "Подтвердил"
  },
  "state": {
    "open": "Активно",
    "closed": "Закрыто",
    "endedAt": "Завершено: {{time}}"
  },
  "ack": {
    "button": "Подтвердить",
    "done": "Событие подтверждено",
    "at": "в {{time}}"
  },
  "duration": {
    "d": "{{count}} д",
    "h": "{{count}} ч",
    "m": "{{count}} мин",
    "running": "продолжается"
  },
  "empty": {
    "openTitle": "Активных событий нет",
    "openText": "Все контролируемые показатели в норме.",
    "title": "События не найдены",
    "text": "По выбранному фильтру событий нет."
  },
  "settings": {
    "m1Title": "Звук критерия 1",
    "m2Title": "Звук критерия 2",
    "sound": "Выберите звук",
    "sounds": {
      "signal_deep": "Глубокий сигнал",
      "siren": "Сирена"
    },
    "configure": "Настройте оповещения",
    "screenTitle": "Оповещение {{level}} (на экране)",
    "screenText": "Если выключить, оповещение не появится на экране",
    "playTitle": "Оповещение {{level}} (звук)",
    "playText": "Если выключить, звук не прозвучит",
    "test": "Проверить",
    "repeat": "Количество повторов",
    "repeatSuffix": "раз",
    "duration": "Длительность, сек",
    "durationSuffix": "сек",
    "repeatError": "Целое число от 1 до 100",
    "durationError": "Целое число от 1 до 3600",
    "save": "Сохранить",
    "cancel": "Отмена",
    "saved": "Настройки сохранены",
    "updatedBy": "Последнее изменение: {{name}}, {{time}}",
    "hint": "Настройки действуют для всех пользователей объекта"
  },
  "bell": {
    "label": "Оповещения",
    "count": "Неподтверждённых событий: {{count}}"
  },
  "banner": {
    "region": "Активные оповещения",
    "title": "{{level}}: {{indicator}} — {{value}}",
    "started": "Начало: {{time}}",
    "threshold": "Порог: {{value}}",
    "view": "Открыть",
    "ack": "Подтвердить",
    "close": "Закрыть",
    "mute": "Выключить звук",
    "enableSound": "Включить звук",
    "blocked": "Браузер заблокировал звук"
  },
  "error": {
    "load": "Не удалось загрузить данные",
    "retry": "Повторить",
    "generic": "Произошла ошибка"
  }
}
